import type { FaireProductEntity } from "../../entity_types/product";

export const p_gpg5qyrya5: FaireProductEntity = {
  token: "p_gpg5qyrya5",
  type: "product",
  name: "Joint Support Wellness Oil",
  brandToken: "b_cev7opt9ab",
  brandName: "Nature's Inventory",
  imageUrl:
    "https://cdn.faire.com/fastly/5de211e3f654bb74edcf4e9a376208f0cb8e43fb13b5a321b2b5a3e4f048d398.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/33039543f7bdb67de6e03e5f7f421056413636612516142b57dd7b43732ee509.jpeg",
  ],
  priceDollars: 11.06,
  description:
    "\nOur Joint Support Wellness Oil is designed to work on the spot to reduce pain and inflammation providing almost instant relief and getting you back into your normal routine.\nThis oil is great for sufferers of chronic joint pain. It will help to keep your joints loose and mobile which in turn will reduce the pain and stiffness.\n\n \n\n INGREDIENTS DIRECTIONS \nCocus Nucifera (fractionated coconut oil), Vitis vinifera (grapeseed oil), rosmarinus officinalis (organic rosemary essential oil), eucalyptus globules (organic eucalyptus essential oil), & matricaria chamomilla (organic chamomile essential oil).  Shake before each use. Apply liberal amounts of oil to\nthe joint and surrounding muscle as often as needed. \n \n",
  tags: [],
  msrpDollars: 22.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:10.839Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
